import React, { useState, useEffect, useRef } from "react";
import { Select, DatePicker, message } from "antd";
import moment from "moment";
import JobStatusService from "../../../Services/JobStatusService";
import Repeater from "./Repeater";
import ExpRepeater from "./ExpRepeater";
import DataParser from "../../../utlits/Dataparser";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import CompanyService from "../../../Services/CompanyService";
import secureLocalStorage from "react-secure-storage";
import { Eye, EyeOff } from "lucide-react";
import axios from "axios";
import { NATIONALITIES, BLOOD_GROUPS, RELIGIONS } from "../../../utlits/constants";
import DesignationService from "../../../Services/DesignationService";

const { Option } = Select;

const EditUser = () => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || `/${DataParser.CompanyIdentifierRole()}/users`;
  const id = params.id;
  const [dataSubmitting, setDataSubmitting] = useState(false);
  const [inputFields, setInputFields] = useState([
    { degree_title: "", institue: "", end_date: "", cert_picture: null },
  ]);

  const [ExpInputFields, setExpInputFields] = useState([
    {
      organization_title: "",
      designation: "",
      start_date: "",
      end_date: "",
      last_salary: "",
    },
  ]);

  const addExpFiled = () => {
    let newfields = {
      organization_title: "",
      designation: "",
      start_date: "",
      end_date: "",
      last_salary: "",
    };
    setExpInputFields([...ExpInputFields, newfields]);
  };

  const addFields = () => {
    let newField = {
      degree_title: "",
      institue: "",
      end_date: "",
      cert_picture: null,
    };
    setInputFields([...inputFields, newField]);
  };

  const [shifts, setShifts] = useState([]);
  const [userPermissions, setUserPermissions] = useState([]);
  const [filename, setFileName] = useState("");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfrimPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [gender, setGender] = useState("");
  const [role, setRole] = useState("");
  const [userShifts, setUserShifts] = useState("");
  const [BusinessPhone, setBusinessPhone] = useState("");
  const [personalMobile, setPersonalMobile] = useState("");
  const [spouse, setSpouse] = useState("");
  const [personalEmail, setPersonalEmail] = useState("");
  const [landLine, setLandline] = useState("");
  const [currentAddress, setCurrentAddress] = useState("");
  const [permanentAddress, setPermanentAddress] = useState("");
  const [nationality, setNationality] = useState("");
  const [emergencyContactName, setEmergencyContactName] = useState("");
  const [emergencyContactPhone, setEmergenctContactPhone] = useState("");
  const [dob, setDob] = useState("");
  const [cnic, setCnic] = useState("");
  const [spouseCnic, setSpouseCnic] = useState("");
  const [maritalStatus, setMaritalStatus] = useState("");
  const [religion, setReligion] = useState("");
  const [bloodGroup, setBloodGroup] = useState("");
  const [personPic, setPersonalPic] = useState(null);
  const [personPic2, setPersonalPic2] = useState(null);
  const [department, setDepartment] = useState("");
  const [isHead, setIsHead] = useState("");
  const [phoneExt, setPhoneExt] = useState("");
  const [relativeInWebsouls, setRealtionInWebsouls] = useState("");
  const [employmentStatus, setEmploymentStatus] = useState("");
  const [dateOfjoining, setDateofJoining] = useState("");
  const [reportsTo, setReportsTo] = useState("");
  const [designation, setDesignation] = useState("");
  const [expDesignation, setExpDesignation] = useState("");
  const [empid, setEmpId] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [EmailError, setEmailError] = useState("");
  const [PasswordError, setPasswordError] = useState("");
  const [ConfirmPasswordError, setConfirmPasswordError] = useState("");
  const [FirstNameError, setFirstNameError] = useState("");
  const [LastNameError, setLastNameError] = useState("");
  const [GenderError, setGenderError] = useState("");
  const [RoleError, setRoleError] = useState("");
  const [SpouseError, setSpouseError] = useState("");
  const [personalEmailError, setpersonalEmailError] = useState("");
  const [PersonalMobileError, setPersonalMobileError] = useState("");
  const [CurrentAddressError, setCurrentAddressError] = useState("");
  const [NationalityError, setNationalityError] = useState("");
  const [DOBError, setDOBError] = useState("");
  const [DepartmentError, setDepartmentError] = useState("");
  const [DesignationError, setDesignationError] = useState("");
  const [RelativeWebsoulsError, setRelativeWebsoulsError] = useState("");
  const [EmployementStatusError, setEmployementStatusError] = useState("");
  const [ReportsToError, setReportsToError] = useState("");
  const [CNICError, setCNICError] = useState("");

  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const fileInputRef = useRef(null);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [rolesList, setRolesList] = useState([]);
  const [deparmentList, setDepartmentList] = useState([]);
  const [ReportList, setReportList] = useState([]);
  const [employmentStatusList, setEmploymentStatusList] = useState([]);
  const [designationList, setDesignationList] = useState([]);

  // Kept for ExpRepeater child component
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: state.isFocused ? "1px solid #0DDFAB" : "1px solid #e1e5eb",
      borderRadius: "10px",
      minHeight: "40px",
      height: "40px",
      boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(13, 223, 171, 0.25)" : "none",
      fontSize: "14px",
      "&:hover": {
        border: state.isFocused ? "1px solid #0DDFAB" : "1px solid #e1e5eb",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 15px",
      height: "40px",
      display: "flex",
      alignItems: "center",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0px",
      padding: "0px",
      caretColor: "black",
      color: "black",
      boxShadow: "none !important",
      outline: "none !important",
      border: "none !important",
      background: "transparent",
      "& input": {
        boxShadow: "none !important",
        outline: "none !important",
        border: "none !important",
        caretColor: "black !important",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      margin: "0px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "40px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#6c757d",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#0DDFAB"
        : state.isFocused
          ? "rgba(13, 223, 171, 0.1)"
          : "transparent",
      color: state.isSelected ? "white" : "black",
      cursor: "pointer",
      "&:active": {
        backgroundColor: "#0DDFAB",
      },
      zIndex: 9999,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const designationOptions = designationList.map((el) => ({
    value: el.name,
    label: el.name,
  }));

  const [docList, setDocList] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const TABS = [
    { label: "Login Credentials", icon: "uil-lock" },
    { label: "Personal Info", icon: "uil-user-circle" },
    { label: "Official Info", icon: "uil-briefcase" },
    { label: "Academic Records", icon: "uil-graduation-cap" },
    { label: "Work Experience", icon: "uil-suitcase" },
    { label: "Documents", icon: "uil-paperclip" },
  ];

  useEffect(() => {
    const upermission = DataParser.CompanyUserPermissions();
    setUserPermissions(upermission || []);
  }, []);

  useEffect(() => {
    if (id) {
      const CompanyId = DataParser.CompanyId();

      CompanyService.viewComapnyUser(id, CompanyId).then((res) => {
        if (res.data === "Un-Athunticated request") {
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }

        const userDetails = res.data.user[0];
        const userAcademic = res.data.academic;
        const userExperice = res.data.experience;
        const userdoc = res.data.docss;

        if (userdoc && userdoc.length > 0) {
          const backendPath = process.env.REACT_APP_USER_DOCS_PATH;
          const existingAttachments = userdoc.map((doc) => {
            const fileName = doc.user_docss;
            const filePath = `${backendPath}${fileName}`;
            const ext = fileName.split(".").pop().toLowerCase();
            const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(ext);
            return {
              _id: doc._id,
              file: fileName,
              preview: isImage ? filePath : null,
              type: isImage ? "image" : "doc",
            };
          });
          setAttachments(existingAttachments);
        }

        setDocList(userdoc);
        setEmail(userDetails.email);
        setFirstName(userDetails.first_name);
        setLastName(userDetails.last_name);
        setGender(userDetails.gender || "");
        setRole(userDetails.role);
        setSpouse(userDetails.spouse_name);
        setBusinessPhone(userDetails.buisness_phone);
        setPersonalEmail(userDetails.personal_email);
        setPersonalMobile(userDetails.personal_mobile);
        setLandline(userDetails.personal_land_line_no);
        setCurrentAddress(userDetails.personal_current_address);
        setPermanentAddress(userDetails.personal_permanent_address);
        setNationality(userDetails.personal_nationality);
        setEmergencyContactName(userDetails.personal_emg_contact_name);
        setEmergenctContactPhone(userDetails.personal_emg_contact_phone);
        setDob(userDetails.dob || "");
        setCnic(userDetails.personal_cnic);
        setSpouseCnic(userDetails.personal_parent_cnic);
        setMaritalStatus(userDetails.personal_marital_status);
        setReligion(userDetails.personal_religion);
        setIsHead(userDetails.is_head);
        setBloodGroup(userDetails.personal_blood_group);
        setDepartment(userDetails.department);
        setPhoneExt(userDetails.phone_ext);
        setRealtionInWebsouls(userDetails.relative_websouls);
        setEmploymentStatus(userDetails.employment_status);
        setDateofJoining(userDetails.joining_date);
        setReportsTo(userDetails.report_to);
        setDesignation(userDetails.designation || "");
        setEmpId(userDetails.empid || "");
        setPersonalPic2(userDetails.image);
        setUserShifts(userDetails?.userShifts);
        setExpInputFields(userExperice);
        setPassword("********");
        setConfrimPassword("********");

        setInputFields(
          (userAcademic || []).map((item) => {
            const previewPath = item.cert_picture
              ? process.env.REACT_APP_USER_DOCS_PATH + item.cert_picture
              : null;
            return { ...item, cert_picture_preview: previewPath };
          })
        );

        const tempUserRoleId = userDetails.role;

        CompanyService.getCompanyRoles(CompanyId).then((res) => {
          if (res.data === "Un-Athunticated request") {
            secureLocalStorage.removeItem("adminInfo");
            secureLocalStorage.removeItem("admins");
            navigate("/");
            return;
          }
          const data = res.data.roles || [];
          setRolesList(data);

          const viewedUserRole = data.find(
            (r) => String(r.id) === String(tempUserRoleId)
          );
          const viewedUserRoleTitle = viewedUserRole?.name || "Unknown";
          const currentUserRole =
            JSON.parse(secureLocalStorage.getItem("adminInfo"))?.user?.userdata
              ?.role_title || "Unknown";

          let disableForm = false;
          if (["Admin", "Company Admin"].includes(currentUserRole)) {
            disableForm = false;
          } else if (currentUserRole === "HR") {
            if (["Admin", "Company Admin", "HR"].includes(viewedUserRoleTitle)) {
              disableForm = true;
            } else {
              disableForm = false;
            }
          } else {
            disableForm = true;
          }
          setIsDisabled(disableForm);
        });
      });

      CompanyService.getCompanyDepartment(CompanyId).then((res) => {
        if (res.data === "Un-Athunticated request") {
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
        }
        setDepartmentList(res.data.departments);
      });
      CompanyService.getCompanyReportsTo(CompanyId).then((res) => {
        if (res.data === "Un-Athunticated request") {
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
        }
        setReportList(res.data.user);
      });
      JobStatusService.getJobStatusService(CompanyId).then((res) => {
        if (res.data === "Un-Athunticated request") {
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
        }
        setEmploymentStatusList(res.data.jobstatus);
      });
      DesignationService.getCompanyDesignation(CompanyId).then((res) => {
        if (res.data === "Un-Athunticated request") {
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
        }
        setDesignationList(res.data?.designations || []);
      });
    }
  }, [id]);

  const emailRef = useRef();
  const passwordRef = useRef();
  const confirmPasswordRef = useRef();
  const firstNameRef = useRef();
  const lastNameRef = useRef();

  const fileInputRefMul = useRef(null);

  const fileIcons = {
    pdf: "📕",
    doc: "📘",
    docx: "📘",
    xls: "📗",
    xlsx: "📗",
    csv: "📗",
    txt: "📄",
    default: "📁",
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    if (newPassword === "********") {
      setPasswordError("");
      return;
    }
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/;
    if (!newPassword) {
      setPasswordError("");
    } else if (!passwordRegex.test(newPassword)) {
      setPasswordError("Password must be at least 8 characters with 1 uppercase, 1 number, and 1 special character!");
    } else {
      setPasswordError("");
    }
    if (confirmPassword && newPassword !== confirmPassword) {
      setConfirmPasswordError("Passwords do not match!");
    } else if (confirmPassword) {
      setConfirmPasswordError("");
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    setConfrimPassword(newConfirmPassword);
    if (newConfirmPassword && newConfirmPassword !== password) {
      setConfirmPasswordError("Passwords do not match!");
    } else {
      setConfirmPasswordError("");
    }
  };

  const handelSubmit = async (e) => {
    e.preventDefault();
    setDataSubmitting(true);
    try {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email || !emailRegex.test(email)) {
        setEmailError("Please enter a valid login email!");
        emailRef.current?.focus();
        setDataSubmitting(false);
        return;
      }

      if (!id || password.trim() !== "********") {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/;
        if (!password || !passwordRegex.test(password)) {
          setPasswordError("Password must be at least 8 characters with 1 uppercase, 1 number, and 1 special character!");
          passwordRef.current?.focus();
          setDataSubmitting(false);
          return;
        }
        if (password !== confirmPassword) {
          setConfirmPasswordError("Passwords do not match!");
          confirmPasswordRef.current?.focus();
          setDataSubmitting(false);
          return;
        }
      }

      if (!firstName.trim()) {
        setFirstNameError("First name is required!");
        firstNameRef.current?.focus();
        setDataSubmitting(false);
        return;
      }
      if (!lastName.trim()) {
        setLastNameError("Last name is required!");
        setDataSubmitting(false);
        return;
      }
      if (!gender) {
        setGenderError("Gender is required!");
        setDataSubmitting(false);
        return;
      }
      if (!role) {
        setRoleError("Please select a role!");
        setDataSubmitting(false);
        return;
      }
      if (!spouse || spouse.trim() === "") {
        setSpouseError("Father/Spouse name is required!");
        setDataSubmitting(false);
        return;
      }
      if (!personalEmail || !emailRegex.test(personalEmail)) {
        setpersonalEmailError("Please enter a valid personal email!");
        setDataSubmitting(false);
        return;
      }
      if (!personalMobile || String(personalMobile).trim().length < 10) {
        setPersonalMobileError("Please enter a valid mobile number (at least 10 digits)!");
        setDataSubmitting(false);
        return;
      }
      if (!currentAddress.trim()) {
        setCurrentAddressError("Current address is required!");
        setDataSubmitting(false);
        return;
      }
      if (!nationality.trim()) {
        setNationalityError("Nationality is required!");
        setDataSubmitting(false);
        return;
      }
      if (!dob) {
        setDOBError("Date of birth is required!");
        setDataSubmitting(false);
        return;
      }
      if (!cnic || String(cnic).trim().length !== 13) {
        setCNICError("Please enter a valid 13-digit CNIC!");
        setDataSubmitting(false);
        return;
      }
      if (!department) {
        setDepartmentError("Department is required!");
        setDataSubmitting(false);
        return;
      }
      if (!designation) {
        setDesignationError("Designation is required!");
        setDataSubmitting(false);
        return;
      }
      if (!relativeInWebsouls) {
        setRelativeWebsoulsError("Please specify if you have any relative in the company!");
        setDataSubmitting(false);
        return;
      }
      if (!employmentStatus) {
        setEmployementStatusError("Employment status is required!");
        setDataSubmitting(false);
        return;
      }
      if (!reportsTo) {
        setReportsToError("Please select a reporting manager!");
        setDataSubmitting(false);
        return;
      }

      const companyId = DataParser.CompanyId();
      const formdata = new FormData();
      formdata.append("company_id", companyId);
      formdata.append("email", email);
      if (password.trim() !== "" && password.trim() !== "********") {
        formdata.append("password", password);
        formdata.append("confirm-password", confirmPassword);
      }
      formdata.append("first_name", firstName);
      formdata.append("last_name", lastName);
      formdata.append("gender", gender);
      formdata.append("role", role);
      formdata.append("spouse_name", spouse);
      formdata.append("personal_email", personalEmail);
      formdata.append("personal_mobile", personalMobile);
      formdata.append("personal_land_line_no", landLine);
      formdata.append("personal_current_address", currentAddress);
      formdata.append("personal_permanent_address", permanentAddress);
      formdata.append("personal_nationality", nationality);
      formdata.append("designation", designation);
      formdata.append("personal_emg_contact_name", emergencyContactName);
      formdata.append("personal_emg_contact_phone", emergencyContactPhone);
      formdata.append("dob", dob);
      formdata.append("personal_cnic", cnic);
      formdata.append("personal_parent_cnic", spouseCnic);
      formdata.append("personal_marital_status", maritalStatus);
      formdata.append("personal_religion", religion);
      formdata.append("personal_blood_group", bloodGroup);
      formdata.append("department", department);
      formdata.append("is_head", isHead);
      formdata.append("buisness_phone", BusinessPhone);
      formdata.append("phone_ext", phoneExt);
      formdata.append("relative_websouls", relativeInWebsouls);
      formdata.append("employment_status", employmentStatus);
      formdata.append("joining_date", dateOfjoining);
      formdata.append("report_to", reportsTo);
      formdata.append("userShift", userShifts);
      formdata.append("empid", empid);

      if (personPic2 instanceof File) {
        formdata.append("file", personPic2);
      } else if (personPic2 === "") {
        formdata.append("removeFile", "true");
      }

      formdata.append("experience", JSON.stringify(ExpInputFields));
      const academicData = inputFields.map(({ cert_picture_preview, ...rest }) => rest);
      formdata.append("academic", JSON.stringify(academicData));
      inputFields.forEach((item) => {
        if (item.cert_picture instanceof File) {
          formdata.append("cert_pictures", item.cert_picture);
        }
      });

      const adminInfo = JSON.parse(secureLocalStorage.getItem("adminInfo"));
      const checkAuth = adminInfo ? adminInfo.authToken : "";

      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}user/update/${id}`,
        formdata,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            authToken: checkAuth,
          },
        }
      );

      if (res.data === "Un-Athunticated request") {
        secureLocalStorage.removeItem("adminInfo");
        secureLocalStorage.removeItem("admins");
        navigate("/");
        return;
      }

      if (attachments && attachments.length > 0) {
        const formData2 = new FormData();
        attachments.forEach((att) => {
          formData2.append("files", att.file);
        });
        await axios.post(
          `${process.env.REACT_APP_BASE_URL}/user/userdocs/${id}`,
          formData2,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              authToken: checkAuth,
            },
          }
        );
      }

      message.success("User updated successfully!");
      if (userPermissions.includes("user-list")) {
        navigate(from || `/${DataParser.CompanyIdentifierRole()}/users`);
      } else {
        navigate(`/${DataParser.CompanyIdentifierRole()}/employee-attendance`);
      }
    } catch (error) {
      console.error("Update failed:", error);
      message.error("Something went wrong. Please try again.");
    } finally {
      setDataSubmitting(false);
    }
  };

  const handleFileChangeMultiple = (e) => {
    const files = Array.from(e.target.files || []);
    const newAttachments = files.map((file) => {
      const ext = file.name.split(".").pop().toLowerCase();
      const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(ext);
      return {
        file,
        preview: isImage ? URL.createObjectURL(file) : null,
        type: isImage ? "image" : "doc",
      };
    });
    setAttachments((prev) => [...prev, ...newAttachments]);
    if (fileInputRefMul.current) fileInputRefMul.current.value = "";
  };

  const handleRemoveMultiple = async (index) => {
    const updated = [...attachments];
    const removedItem = updated[index];
    if (typeof removedItem.file === "string" && removedItem._id) {
      const adminInfo = JSON.parse(secureLocalStorage.getItem("adminInfo"));
      const checkAuth = adminInfo ? adminInfo.authToken : "";
      await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/doc/deletedoc/${removedItem._id}`,
        { headers: { authToken: checkAuth } }
      );
    }
    updated.splice(index, 1);
    setAttachments(updated);
    if (updated.length === 0 && fileInputRefMul.current) {
      fileInputRefMul.current.value = "";
    }
  };

  const sectionHeader = (icon, title) => (
    <h5 className="mb-3" style={{ borderBottom: "2px solid #0bc698", paddingBottom: "8px", fontWeight: 700, color: "#000" }}>
      <i className={`${icon} me-2`}></i>{title}
    </h5>
  );

  return (
    <>
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0 d-flex justify-content-end" style={{ padding: "4px 0 8px" }}>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={`/${DataParser.CompanyIdentifierRole()}/users`}>All Employees</Link>
                  </li>
                  <li className="breadcrumb-item active">Edit Employee</li>
                </ol>
              </div>
            </div>

            {/* ── Tab Bar ── */}
            <div className="user-form-tab-bar" style={{ marginTop: "16px" }}>
              <div style={{ display: "flex", flex: 1 }}>
                {TABS.map((tab, i) => (
                  <div key={i} className={`user-form-tab${activeTab === i ? " active" : ""}`} onClick={() => setActiveTab(i)}>
                    <i className={tab.icon} />
                    {tab.label}
                  </div>
                ))}
              </div>
              {activeTab < TABS.length - 1 ? (
                <button type="button" onClick={() => setActiveTab(activeTab + 1)} style={{ background: "#1D1D1D", color: "#fff", border: "none", borderRadius: "6px", padding: "8px 22px", fontWeight: 600, fontSize: "14px", cursor: "pointer", marginLeft: "16px", whiteSpace: "nowrap" }}>
                  Next
                </button>
              ) : !isDisabled && (
                dataSubmitting ? (
                  <button disabled style={{ background: "#0bc698", color: "#fff", border: "none", borderRadius: "6px", padding: "8px 22px", fontWeight: 600, fontSize: "14px", marginLeft: "16px", minWidth: "160px", cursor: "not-allowed" }}>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Updating...
                  </button>
                ) : (
                  <button type="submit" form="edit-user-form" style={{ background: "#0bc698", color: "#fff", border: "none", borderRadius: "6px", padding: "8px 22px", fontWeight: 600, fontSize: "14px", cursor: "pointer", marginLeft: "16px", whiteSpace: "nowrap" }}>
                    Save Changes
                  </button>
                )
              )}
            </div>

            <div className="row">
              <div className="col-12 px-0">
                <div className="card" style={{ backgroundColor: "transparent", boxShadow: "none", border: "none" }}>
                  <div className="card-body" style={{ padding: "0" }}>
                    <form id="edit-user-form" onSubmit={(e) => handelSubmit(e)}>

                      {activeTab === 0 && (<>
                      <div className="row">
                        <div className="col">
                          <div className="float-input-wrap mb-3">
                            <input
                              type="email"
                              id="edit-login-email"
                              ref={emailRef}
                              placeholder=" "
                              disabled
                              value={email}
                              onChange={(e) => {
                                setEmail(e.target.value);
                                if (e.target.value.trim() !== "") setEmailError("");
                              }}
                              className={EmailError ? "is-invalid" : ""}
                            />
                            <label htmlFor="edit-login-email">Login Email*</label>
                            {EmailError && <small className="text-danger mt-1 d-block">{EmailError}</small>}
                          </div>
                        </div>
                        <div className="col">
                          <div className="float-input-wrap mb-3">
                            <input
                              type={showPassword ? "text" : "password"}
                              id="edit-password"
                              ref={passwordRef}
                              placeholder=" "
                              value={password}
                              onChange={handlePasswordChange}
                              className={PasswordError ? "is-invalid" : ""}
                              style={{ paddingRight: "40px", backgroundImage: "none" }}
                            />
                            <label htmlFor="edit-password">Password*</label>
                            <button
                              type="button"
                              onClick={() => setShowPassword(!showPassword)}
                              style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#6c757d" }}
                            >
                              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                            </button>
                            {PasswordError && <small className="text-danger mt-1 d-block">{PasswordError}</small>}
                          </div>
                        </div>
                        <div className="col">
                          <div className="float-input-wrap mb-3">
                            <input
                              type={showConfirmPassword ? "text" : "password"}
                              id="edit-confirm-password"
                              ref={confirmPasswordRef}
                              placeholder=" "
                              value={confirmPassword}
                              onChange={handleConfirmPasswordChange}
                              className={ConfirmPasswordError ? "is-invalid" : ""}
                              style={{ paddingRight: "40px", backgroundImage: "none" }}
                            />
                            <label htmlFor="edit-confirm-password">Confirm Password*</label>
                            <button
                              type="button"
                              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                              style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#6c757d" }}
                            >
                              {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                            </button>
                            {ConfirmPasswordError && <small className="text-danger mt-1 d-block">{ConfirmPasswordError}</small>}
                          </div>
                        </div>
                      </div>
                      </>)}

                      {activeTab === 1 && (<>
                      <div className="row">
                        <div className="col-12 col-sm-4">
                          <div className="float-input-wrap mb-3">
                            <input
                              type="text"
                              id="edit-firstName"
                              ref={firstNameRef}
                              placeholder=" "
                              disabled={isDisabled}
                              value={firstName}
                              onChange={(e) => {
                                setFirstName(e.target.value);
                                if (e.target.value.trim() !== "") setFirstNameError("");
                              }}
                              className={FirstNameError ? "is-invalid" : ""}
                            />
                            <label htmlFor="edit-firstName">First Name*</label>
                            {FirstNameError && <small className="text-danger mt-1 d-block">{FirstNameError}</small>}
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="float-input-wrap mb-3">
                            <input
                              type="text"
                              id="edit-lastName"
                              placeholder=" "
                              disabled={isDisabled}
                              value={lastName}
                              onChange={(e) => {
                                setLastName(e.target.value);
                                if (e.target.value.trim() !== "") setLastNameError("");
                              }}
                              className={LastNameError ? "is-invalid" : ""}
                            />
                            <label htmlFor="edit-lastName">Last Name*</label>
                            {LastNameError && <small className="text-danger mt-1 d-block">{LastNameError}</small>}
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className={`float-select-wrap mb-3 ${gender ? "has-value" : ""} ${GenderError ? " select-error" : ""}`}>
                            <label>Gender*</label>
                            <Select
                              value={gender || undefined}
                              onChange={(val) => { setGender(val); if (val) setGenderError(""); }}
                              placeholder=""
                              style={{ width: "100%" }}
                              disabled={isDisabled}
                            >
                              <Option value="Male">Male</Option>
                              <Option value="Female">Female</Option>
                              <Option value="Other">Other</Option>
                            </Select>
                            {GenderError && <small className="text-danger mt-1 d-block">{GenderError}</small>}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12 col-sm-4">
                          <div className="float-input-wrap mb-3">
                            <input
                              type="text"
                              id="edit-spouse"
                              placeholder=" "
                              disabled={isDisabled}
                              value={spouse}
                              onChange={(e) => {
                                setSpouse(e.target.value);
                                if (e.target.value.trim() !== "") setSpouseError("");
                              }}
                              className={SpouseError ? "is-invalid" : ""}
                            />
                            <label htmlFor="edit-spouse">Spouse or Father's Name*</label>
                            {SpouseError && <small className="text-danger mt-1 d-block">{SpouseError}</small>}
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="float-input-wrap mb-3">
                            <input
                              type="email"
                              id="edit-personalEmail"
                              placeholder=" "
                              disabled={isDisabled}
                              value={personalEmail}
                              onChange={(e) => {
                                setPersonalEmail(e.target.value);
                                if (e.target.value.trim() !== "") setpersonalEmailError("");
                              }}
                              className={personalEmailError ? "is-invalid" : ""}
                            />
                            <label htmlFor="edit-personalEmail">Personal Email*</label>
                            {personalEmailError && <small className="text-danger mt-1 d-block">{personalEmailError}</small>}
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="float-input-wrap mb-3">
                            <input
                              type="tel"
                              id="edit-personalMobile"
                              placeholder=" "
                              disabled={isDisabled}
                              value={personalMobile}
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, '');
                                setPersonalMobile(value);
                                if (value.trim() !== "") setPersonalMobileError("");
                              }}
                              className={PersonalMobileError ? "is-invalid" : ""}
                            />
                            <label htmlFor="edit-personalMobile">Personal Mobile*</label>
                            {PersonalMobileError && <small className="text-danger mt-1 d-block">{PersonalMobileError}</small>}
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="float-input-wrap mb-3">
                            <input
                              type="tel"
                              id="edit-landLine"
                              placeholder=" "
                              disabled={isDisabled}
                              value={landLine}
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, '');
                                setLandline(value);
                              }}
                            />
                            <label htmlFor="edit-landLine">Landline</label>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="float-input-wrap mb-3">
                            <input
                              type="text"
                              id="edit-currentAddress"
                              placeholder=" "
                              disabled={isDisabled}
                              value={currentAddress}
                              onChange={(e) => {
                                setCurrentAddress(e.target.value);
                                if (e.target.value.trim() !== "") setCurrentAddressError("");
                              }}
                              className={CurrentAddressError ? "is-invalid" : ""}
                            />
                            <label htmlFor="edit-currentAddress">Current Address*</label>
                            {CurrentAddressError && <small className="text-danger mt-1 d-block">{CurrentAddressError}</small>}
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="float-input-wrap mb-3">
                            <input
                              type="text"
                              id="edit-permanentAddress"
                              placeholder=" "
                              disabled={isDisabled}
                              value={permanentAddress}
                              onChange={(e) => setPermanentAddress(e.target.value)}
                            />
                            <label htmlFor="edit-permanentAddress">Permanent Address</label>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className={`float-select-wrap mb-3 ${nationality ? "has-value" : ""} ${NationalityError ? " select-error" : ""}`}>
                            <label>Nationality*</label>
                            <Select
                              value={nationality || undefined}
                              onChange={(val) => { setNationality(val); if (val) setNationalityError(""); }}
                              placeholder=""
                              style={{ width: "100%" }}
                              disabled={isDisabled}
                              showSearch
                              filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {NATIONALITIES.map((nat) => (
                                <Option key={nat} value={nat}>{nat}</Option>
                              ))}
                            </Select>
                            {NationalityError && <small className="text-danger mt-1 d-block">{NationalityError}</small>}
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="float-input-wrap mb-3">
                            <input
                              type="text"
                              id="edit-emergencyName"
                              placeholder=" "
                              disabled={isDisabled}
                              value={emergencyContactName}
                              onChange={(e) => setEmergencyContactName(e.target.value)}
                            />
                            <label htmlFor="edit-emergencyName">Emergency Contact Name</label>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="float-input-wrap mb-3">
                            <input
                              type="tel"
                              id="edit-emergencyPhone"
                              placeholder=" "
                              disabled={isDisabled}
                              value={emergencyContactPhone}
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, '');
                                setEmergenctContactPhone(value);
                              }}
                            />
                            <label htmlFor="edit-emergencyPhone">Emergency Contact Phone</label>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className={`float-select-wrap mb-3 ${dob ? "has-value" : ""} ${DOBError ? " select-error" : ""}`}>
                            <label>Date Of Birth*</label>
                            <DatePicker
                              style={{ width: "100%" }}
                              format="DD-MM-YYYY"
                              placeholder=""
                              value={dob ? moment(dob, "YYYY-MM-DD") : null}
                              onChange={(val) => { setDob(val ? val.format("YYYY-MM-DD") : ""); if (val) setDOBError(""); }}
                              disabled={isDisabled}
                            />
                            {DOBError && <small className="text-danger mt-1 d-block">{DOBError}</small>}
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="float-input-wrap mb-3">
                            <input
                              type="tel"
                              id="edit-cnic"
                              placeholder=" "
                              disabled={isDisabled}
                              value={cnic}
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, '');
                                setCnic(value);
                                if (value.trim() !== "") setCNICError("");
                              }}
                              className={CNICError ? "is-invalid" : ""}
                            />
                            <label htmlFor="edit-cnic">CNIC*</label>
                            {CNICError && <small className="text-danger mt-1 d-block">{CNICError}</small>}
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="float-input-wrap mb-3">
                            <input
                              type="tel"
                              id="edit-spouseCnic"
                              placeholder=" "
                              disabled={isDisabled}
                              value={spouseCnic}
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, '');
                                setSpouseCnic(value);
                              }}
                            />
                            <label htmlFor="edit-spouseCnic">Parent/Spouse CNIC</label>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className={`float-select-wrap mb-3 ${maritalStatus ? "has-value" : ""}`}>
                            <label>Marital Status</label>
                            <Select
                              value={maritalStatus || undefined}
                              onChange={(val) => setMaritalStatus(val || "")}
                              placeholder=""
                              style={{ width: "100%" }}
                              disabled={isDisabled}
                              allowClear
                            >
                              <Option value="Single">Single</Option>
                              <Option value="Married">Married</Option>
                            </Select>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className={`float-select-wrap mb-3 ${religion ? "has-value" : ""}`}>
                            <label>Religion</label>
                            <Select
                              value={religion || undefined}
                              onChange={(val) => setReligion(val || "")}
                              placeholder=""
                              style={{ width: "100%" }}
                              disabled={isDisabled}
                              showSearch
                              allowClear
                              filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {RELIGIONS.map((rel) => (
                                <Option key={rel} value={rel}>{rel}</Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className={`float-select-wrap mb-3 ${bloodGroup ? "has-value" : ""}`}>
                            <label>Blood Group</label>
                            <Select
                              value={bloodGroup || undefined}
                              onChange={(val) => setBloodGroup(val || "")}
                              placeholder=""
                              style={{ width: "100%" }}
                              disabled={isDisabled}
                              allowClear
                            >
                              {BLOOD_GROUPS.map((bg) => (
                                <Option key={bg} value={bg}>{bg}</Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className={`float-select-wrap mb-2 ${personPic2 || selectedFile ? "has-value" : ""}`}>
                            <label>Upload Picture</label>
                            <div
                              style={{ height: "44px", border: "1.5px solid #d0d0d0", borderRadius: "8px", padding: "0 14px", display: "flex", alignItems: "center", fontSize: "14px", color: "#6c757d", background: isDisabled ? "#f5f6f8" : "#fff", cursor: isDisabled ? "not-allowed" : "pointer", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}
                              onClick={() => !isDisabled && fileInputRef.current?.click()}
                            >
                              {selectedFile ? selectedFile.name : personPic2 ? personPic2.split("/").pop() : ""}
                            </div>
                            <input
                              type="file"
                              id="uploadFile"
                              disabled={isDisabled}
                              ref={fileInputRef}
                              accept="image/*"
                              style={{ display: "none" }}
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) { setSelectedFile(file); setPreview(URL.createObjectURL(file)); setPersonalPic2(file); }
                              }}
                            />
                          </div>
                          {(preview || personPic2) && (() => {
                            const picName = selectedFile ? selectedFile.name : personPic2 ? personPic2.split("/").pop() : "";
                            const imgUrl = preview ? preview : `${process.env.REACT_APP_USER_DOCS_PATH}${encodeURIComponent(personPic2)}`;
                            return (
                              <div className="mt-2">
                                <div
                                  title={picName}
                                  style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "#1e2030", borderRadius: "5px", padding: "5px 10px 5px 12px", fontSize: "13px", color: "#0bc698", maxWidth: "100%", fontWeight: 500 }}
                                >
                                  <i className="uil-import" style={{ fontSize: "14px", flexShrink: 0, cursor: "pointer" }} onClick={() => imgUrl && window.open(imgUrl, "_blank")} />
                                  <span onClick={() => imgUrl && window.open(imgUrl, "_blank")} style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1, cursor: "pointer" }}>
                                    {picName}
                                  </span>
                                  {!isDisabled && (
                                    <span
                                      onClick={() => { setSelectedFile(""); setPreview(null); setPersonalPic2(""); if (fileInputRef.current) fileInputRef.current.value = ""; }}
                                      style={{ flexShrink: 0, cursor: "pointer", fontSize: "17px", lineHeight: 1, marginLeft: "2px" }}
                                    >
                                      ×
                                    </span>
                                  )}
                                </div>
                              </div>
                            );
                          })()}
                        </div>
                      </div>
                      </>)}

                      {activeTab === 2 && (<>
                      <div className="row">
                        <div className="col-12 col-sm-4">
                          <div className={`float-select-wrap mb-3 ${role ? "has-value" : ""} ${RoleError ? " select-error" : ""}`}>
                            <label>Role*</label>
                            <Select
                              value={role || undefined}
                              onChange={(val) => { setRole(val); if (val) setRoleError(""); }}
                              placeholder=""
                              style={{ width: "100%" }}
                              disabled={isDisabled}
                              showSearch
                              filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {rolesList.map((el) => (
                                <Option key={el.id} value={el.id}>{el.name}</Option>
                              ))}
                            </Select>
                            {RoleError && <small className="text-danger mt-1 d-block">{RoleError}</small>}
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="float-input-wrap mb-3">
                            <input
                              type="text"
                              id="edit-empid"
                              placeholder=" "
                              disabled={isDisabled}
                              value={empid}
                              onChange={(e) => setEmpId(e.target.value)}
                            />
                            <label htmlFor="edit-empid">Employee ID</label>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className={`float-select-wrap mb-3 ${department ? "has-value" : ""} ${DepartmentError ? " select-error" : ""}`}>
                            <label>Department*</label>
                            <Select
                              value={department || undefined}
                              onChange={(val) => { setDepartment(val); if (val) setDepartmentError(""); }}
                              placeholder=""
                              style={{ width: "100%" }}
                              disabled={isDisabled}
                              showSearch
                              filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {deparmentList && deparmentList.map((el) => (
                                <Option key={el.id} value={el.id}>{el.name}</Option>
                              ))}
                            </Select>
                            {DepartmentError && <small className="text-danger mt-1 d-block">{DepartmentError}</small>}
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className={`float-select-wrap mb-3 ${designation ? "has-value" : ""} ${DesignationError ? " select-error" : ""}`}>
                            <label>Designation*</label>
                            <Select
                              value={designation || undefined}
                              onChange={(val) => { setDesignation(val || ""); if (val) setDesignationError(""); }}
                              placeholder=""
                              style={{ width: "100%" }}
                              disabled={isDisabled}
                              showSearch
                              allowClear
                              filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {designationList.map((el) => (
                                <Option key={el.name} value={el.name}>{el.name}</Option>
                              ))}
                            </Select>
                            {DesignationError && <small className="text-danger mt-1 d-block">{DesignationError}</small>}
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className={`float-select-wrap mb-3 ${isHead ? "has-value" : ""}`}>
                            <label>Is Head</label>
                            <Select
                              value={isHead || undefined}
                              onChange={(val) => setIsHead(val || "")}
                              placeholder=""
                              style={{ width: "100%" }}
                              disabled={isDisabled}
                              allowClear
                            >
                              <Option value="yes">Yes</Option>
                              <Option value="no">No</Option>
                            </Select>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="float-input-wrap mb-3">
                            <input
                              type="tel"
                              id="edit-businessPhone"
                              placeholder=" "
                              disabled={isDisabled}
                              value={BusinessPhone}
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, '');
                                setBusinessPhone(value);
                              }}
                            />
                            <label htmlFor="edit-businessPhone">Business Phone</label>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className="float-input-wrap mb-3">
                            <input
                              type="tel"
                              id="edit-phoneExt"
                              placeholder=" "
                              disabled={isDisabled}
                              value={phoneExt}
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, '');
                                setPhoneExt(value);
                              }}
                            />
                            <label htmlFor="edit-phoneExt">Phone Ext.</label>
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className={`float-select-wrap mb-3 ${relativeInWebsouls ? "has-value" : ""} ${RelativeWebsoulsError ? " select-error" : ""}`}>
                            <label>Any Relative in Websouls?*</label>
                            <Select
                              value={relativeInWebsouls || undefined}
                              onChange={(val) => { setRealtionInWebsouls(val); if (val) setRelativeWebsoulsError(""); }}
                              placeholder=""
                              style={{ width: "100%" }}
                              disabled={isDisabled}
                            >
                              <Option value="yes">Yes</Option>
                              <Option value="no">No</Option>
                            </Select>
                            {RelativeWebsoulsError && <small className="text-danger mt-1 d-block">{RelativeWebsoulsError}</small>}
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className={`float-select-wrap mb-3 ${employmentStatus ? "has-value" : ""} ${EmployementStatusError ? " select-error" : ""}`}>
                            <label>Employment Status*</label>
                            <Select
                              value={employmentStatus || undefined}
                              onChange={(val) => { setEmploymentStatus(val); if (val) setEmployementStatusError(""); }}
                              placeholder=""
                              style={{ width: "100%" }}
                              disabled={isDisabled}
                              showSearch
                              filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {employmentStatusList && employmentStatusList.map((elsa) => (
                                <Option key={elsa.id} value={elsa.id}>{elsa.name}</Option>
                              ))}
                            </Select>
                            {EmployementStatusError && <small className="text-danger mt-1 d-block">{EmployementStatusError}</small>}
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className={`float-select-wrap mb-3 ${dateOfjoining ? "has-value" : ""}`}>
                            <label>Date of Joining</label>
                            <DatePicker
                              style={{ width: "100%" }}
                              format="DD-MM-YYYY"
                              placeholder=""
                              value={dateOfjoining ? moment(dateOfjoining, "YYYY-MM-DD") : null}
                              onChange={(val) => setDateofJoining(val ? val.format("YYYY-MM-DD") : "")}
                              disabled={isDisabled}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-sm-4">
                          <div className={`float-select-wrap mb-3${ReportsToError ? " select-error" : ""}`}>
                            <label>Report To*</label>
                            <Select
                              value={reportsTo || undefined}
                              onChange={(val) => { setReportsTo(val); if (val) setReportsToError(""); }}
                              placeholder="Select Reporting Manager"
                              style={{ width: "100%" }}
                              disabled={isDisabled}
                              showSearch
                              filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {ReportList && ReportList.map((elsss) => (
                                <Option key={elsss.id} value={elsss.id}>
                                  {elsss.first_name} {elsss.last_name}
                                </Option>
                              ))}
                            </Select>
                            {ReportsToError && <small className="text-danger mt-1 d-block">{ReportsToError}</small>}
                          </div>
                        </div>
                      </div>
                      </>)}

                      {activeTab === 3 && (<>
                      <div className="row">
                        <div className="repeater-default">
                          <div data-repeater-list="academic">
                            <div data-repeater-item="">
                              <Repeater
                                disabled={isDisabled}
                                inputFields={inputFields}
                                setInputFields={setInputFields}
                                addFields={addFields}
                              />
                            </div>
                          </div>
                          <div className="form-group overflow-hidden row">
                            <div className="col-12 mb-3">
                              <button
                                type="button"
                                disabled={isDisabled}
                                data-repeater-create=""
                                onClick={addFields}
                                className="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1 add_new_user"
                              >
                                <i className="icon-plus4" />
                                <span>+</span> Add More
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      </>)}

                      {activeTab === 4 && (<>
                      <div className="row">
                        <div className="repeater-default">
                          <div data-repeater-list="experience">
                            <div data-repeater-item="">
                              <ExpRepeater
                                disabled={isDisabled}
                                ExpInputFields={ExpInputFields}
                                setExpInputFields={setExpInputFields}
                                designationOptions={designationOptions}
                                customStyles={customStyles}
                              />
                            </div>
                          </div>
                          <div className="form-group overflow-hidden row">
                            <div className="col-12 mb-3">
                              <button
                                type="button"
                                disabled={isDisabled}
                                onClick={addExpFiled}
                                className="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1 add_new_user"
                              >
                                <i className="icon-plus4" />
                                <span>+</span> Add More
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      </>)}

                      {activeTab === 5 && (<>
                      <div className="row">
                        <div className="col-12 col-sm-4">
                          <div className={`float-select-wrap mb-2 ${attachments.length > 0 ? "has-value" : ""}`}>
                            <label>Upload Attachments</label>
                            <div
                              style={{ height: "44px", border: "1.5px solid #d0d0d0", borderRadius: "8px", padding: "0 14px", display: "flex", alignItems: "center", fontSize: "14px", color: "#6c757d", background: isDisabled ? "#f5f6f8" : "#fff", cursor: isDisabled ? "not-allowed" : "pointer", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}
                              onClick={() => { if (!isDisabled) fileInputRefMul.current?.click(); }}
                            >
                              {attachments.length > 0 ? `${attachments.length} file${attachments.length > 1 ? "s" : ""} selected` : ""}
                            </div>
                            <input id="attachments" multiple type="file" ref={fileInputRefMul} accept="*/*" disabled={isDisabled} style={{ display: "none" }} onChange={handleFileChangeMultiple} />
                          </div>
                          {attachments.length > 0 && (
                            <div className="d-flex flex-wrap mt-2" style={{ gap: "8px" }}>
                              {attachments.map((att, index) => {
                                const fileName = typeof att.file === "string" ? att.file : att.file.name;
                                const backendPath = process.env.REACT_APP_USER_DOCS_PATH;
                                const src = att.preview || (typeof att.file === "string" ? `${backendPath}${att.file}` : null);
                                const handleDownload = () => {
                                  if (!src) return;
                                  const link = document.createElement("a");
                                  link.href = src;
                                  link.download = fileName;
                                  link.click();
                                };
                                return (
                                  <div
                                    key={index}
                                    title={fileName}
                                    style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "#1e2030", borderRadius: "5px", padding: "5px 10px 5px 12px", fontSize: "13px", color: "#0bc698", maxWidth: "240px", fontWeight: 500, opacity: isDisabled ? 0.7 : 1 }}
                                  >
                                    <i
                                      className="uil-import"
                                      style={{ fontSize: "14px", flexShrink: 0, cursor: isDisabled ? "not-allowed" : "pointer" }}
                                      onClick={!isDisabled ? handleDownload : undefined}
                                    />
                                    <span
                                      onClick={!isDisabled ? handleDownload : undefined}
                                      style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1, cursor: isDisabled ? "default" : "pointer" }}
                                    >
                                      {fileName}
                                    </span>
                                    {!isDisabled && (
                                      <span
                                        onClick={(e) => { e.stopPropagation(); handleRemoveMultiple(index); }}
                                        style={{ flexShrink: 0, cursor: "pointer", fontSize: "17px", lineHeight: 1, marginLeft: "2px" }}
                                      >
                                        ×
                                      </span>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                      </>)}

                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditUser;
